/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'project-actions.project-content.archive-error-title': 'Obnovení projektu se nezdařilo',
  'project-actions.project-content.archive-project': 'Archivovat projekt',
  'project-actions.project-content.archive-restore-error-description':
    'Změny projektu nelze uložit. Zkuste to znovu později.',
  'project-actions.project-content.copy-link': 'Kopírovat odkaz',
  'project-actions.project-content.copy-project': 'Kopírovat projekt',
  'project-actions.project-content.copy-project.cancel': 'Zrušit',
  'project-actions.project-content.copy-project.close-modal': 'Zavřít modální okno',
  'project-actions.project-content.copy-project.error': 'Pojmenujte projekt, aby všichni věděli, o čem je.',
  'project-actions.project-content.copy-project.failed-description':
    'Při klonování projektu došlo k chybě. Zkuste to znovu později.',
  'project-actions.project-content.copy-project.failed-description-forbidden':
    'Ke kopírování tohoto projektu nemáte oprávnění.',
  'project-actions.project-content.copy-project.failed-title': 'Klonování tohoto projektu se nezdařilo.',
  'project-actions.project-content.copy-project.followers': 'Sledující',
  'project-actions.project-content.copy-project.include': 'Zahrnout',
  'project-actions.project-content.copy-project.links': 'Odkazy',
  'project-actions.project-content.copy-project.project-name': 'Název projektu',
  'project-actions.project-content.copy-project.submit': 'Odeslat',
  'project-actions.project-content.copy-project.success-description': 'Projekt byl úspěšně klonován.',
  'project-actions.project-content.copy-project.success-link': 'Podívejte se na klonovaný projekt.',
  'project-actions.project-content.copy-project.success-title': 'Projekt {projectName} byl klonován.',
  'project-actions.project-content.copy-project.title': 'Kopírovat projekt',
  'project-actions.project-content.follow': 'Sledovat',
  'project-actions.project-content.follow-confirmation-description':
    'Každé pondělní ráno vám zašleme souhrn aktualizací ze všech projektů, které sledujete. <a>Proč pondělky?</a>',
  'project-actions.project-content.follow-confirmation-title': '🙌🏼 Nyní sledujete tento projekt!',
  'project-actions.project-content.follow-error-title': 'Sledování projektu se nepodařilo aktivovat',
  'project-actions.project-content.follow-unfollow-error-description':
    'Změny projektu nelze uložit. Zkuste to znovu později.',
  'project-actions.project-content.restore-project': 'Obnovit projekt',
  'project-actions.project-content.share': 'Sdílet',
  'project-actions.project-content.unfollow': 'Přestat sledovat',
  'project-actions.project-content.unfollow-error-title': 'Sledování projektu se nepodařilo zrušit',
};
